import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ConfirmationService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Observable, Subscription, debounceTime } from 'rxjs';
import { FINAL_USERS_COLUMNS, FINAL_USERS_TABLE_HEADER, FINAL_USERS_PAGE_SIZE_OPTIONS, FINAL_USERS_PAGE_DEFAULT_SIZE } from 'src/app/conf/final-users';
import { User } from 'src/app/model/user';
import * as UserFileActions from 'src/app/store/user-file/user-file.actions';
import { AppState } from 'src/app/store/app.reducer';
import { TranslateService } from '@ngx-translate/core';
import { StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';
import { selectIsImpersMode, selectUser } from 'src/app/store/user/user.selector';
import { FormControl, FormGroup } from '@angular/forms';
import { ThGroup } from 'src/app/model/api/data-rest';
import { selectCurrentThGroupFinalUsers, selectThGroupRemovedSharing, selectThGroupRemovingSharing, selectThGroupShareInvitationRevoked, selectThGroupShareInvitationRevoking } from 'src/app/store/device-th/device-th.selector';
import * as DeviceThActions from 'src/app/store/device-th/device-th.actions';

@Component({
	selector: 'app-th-final-users',
	templateUrl: './th-final-users.component.html',
	providers: [ConfirmationService, DialogService]
})

export class ThFinalUsersComponent implements OnInit, OnDestroy {

	// deviceFinalUserRemoteClients$: Observable<Map<number, RemoteClients> | undefined>;
	// deviceFinalUserRemoteClientsSub: Subscription | undefined;

	currentThGroupFinalUsers$: Observable<User[] | undefined>;
	currentThGroupFinalUsersSub: Subscription | undefined;

	// shared$: Observable<boolean | undefined>;
	// sharedSub: Subscription | undefined;

	// remoteClientDeleted: boolean;
	// remoteClientDeleted$: Observable<boolean | undefined>;
	// remoteClientDeletedSub: Subscription | undefined;

	usersColumns = FINAL_USERS_COLUMNS;
	displayedColumns: string[] = FINAL_USERS_TABLE_HEADER;

	// clientsColumns = FINAL_USERS_REMOTE_CLIENTS_COLUMNS;
	// displayedClientsColumns = FINAL_USERS_REMOTE_CLIENTS_TABLE_HEADER;
	pageSizeOptions = FINAL_USERS_PAGE_SIZE_OPTIONS;
	pageSize = FINAL_USERS_PAGE_DEFAULT_SIZE;
	totalRecords = 0;

	// pageSizeRemoteClients = REMOTE_CLIENTS_PAGE_DEFAULT_SIZE;
	// maxSlots = 0;
	// totalRecordsRemoteClients = 0;

	finalUsers: User[];
	finalUsersFilter: User[];
	totalRecordsFilter = 0;

	// finalUserRemotes: Map<number, RemoteClients>;

	// currentDevice: Device;
	// currentDevice$: Observable<Device | undefined>;
	// currentDeviceSub: Subscription | undefined;

	// exporting: boolean;
	// exporting$: Observable<boolean | undefined>;
	// exportingSub: Subscription | undefined;

	// deleted: boolean;
	// deleted$: Observable<boolean | undefined>;
	// deletedSub: Subscription | undefined;

	// deleting: boolean;
	// deleting$: Observable<boolean | undefined>;
	// deletingSub: Subscription | undefined;

	// importing: boolean;
	// importing$: Observable<boolean | undefined>;
	// importingSub: Subscription;

	// imported: boolean;
	// imported$: Observable<boolean | undefined>;
	// importedSub: Subscription;

	currentUser: User;
	currentUser$: Observable<User | undefined>;
	currentUserSub: Subscription | undefined;

	isImpersMode: boolean;
	isImpersMode$: Observable<boolean | undefined>;
	isImpersModeSub: Subscription | undefined;

	// remoteClientLockingUnlocking: boolean;
	// remoteClientLockingUnlocking$: Observable<boolean | undefined>;
	// remoteClientLockingUnlockingSub: Subscription;

	// remoteClientLockedUnlocked$: Observable<boolean | undefined>;
	// remoteClientLockedUnlockedSub: Subscription;

	// remoteClientDeleting: boolean;
	// remoteClientDeleting$: Observable<boolean | undefined>;
	// remoteClientDeletingSub: Subscription;

	thGroupShareInvitationRevoking: boolean;
	thGroupShareInvitationRevoking$: Observable<boolean | undefined>;
	thGroupShareInvitationRevokingSub: Subscription;

	thGroupShareInvitationRevoked: boolean;
	thGroupShareInvitationRevoked$: Observable<boolean | undefined>;
	thGroupShareInvitationRevokedSub: Subscription;

	thGroupSharingRemoving: boolean;
	thGroupSharingRemoving$: Observable<boolean | undefined>;
	thGroupSharingRemovingSub: Subscription;

	thGroupRemovedShared: boolean;
	thGroupRemovedShared$: Observable<boolean | undefined>;
	thGroupRemovedSharedSub: Subscription;

	// device: Device;
	// device$: Observable<Device | undefined>;
	// deviceSub: Subscription | undefined;

	acceptButtonStyle: string;
	rejectButtonStyle: string;

	// remoteMax: number;
	// clientsNum: number[] = [1, 2, 3, 4, 5];

	/* Search */
	statusType: any[] = [];

	filterSub: Subscription;
	filterStatusSub: Subscription;
	filterForm: FormGroup;

	thGroup: ThGroup;

	/* Search */
	screenWidth: number;

	ref: DynamicDialogRef | undefined;

	constructor(
		private store: Store<AppState>,
		private translate: TranslateService,
		public confirmationService: ConfirmationService,
		public dialogService: DialogService,
		public config: DynamicDialogConfig,
	) {
		this.initSelectors();
		this.thGroup = this.config.data.thGroup;
	}

	initSelectors(): void {
		// Store selectors
		this.currentThGroupFinalUsers$ = this.store.select(selectCurrentThGroupFinalUsers);
		
		// this.deviceFinalUserRemoteClients$ = this.store.select(selectCurrentDeviceFinalUserRemoteClients);
		// this.shared$ = this.store.select(selectShared);
		// this.remoteClientDeleted$ = this.store.select(selectRemoteClientDeleted);
		// this.currentDevice$ = this.store.select(selectCurrentDevice);
		// this.exporting$ = this.store.select(selectExportingFinalUsersList);
		// this.deleting$ = this.store.select(selectDeletingFinalUsers);
		// this.deleted$ = this.store.select(selectDeletedFinalUsers);
		// this.importing$ = this.store.select(selectImportingFinalUsers);
		// this.imported$ = this.store.select(selectImportedFinalUsers);
		// this.remoteClientDeleting$ = this.store.select(selectRemoteClientDeleting);
		// this.remoteClientLockingUnlocking$ = this.store.select(selectRemoteClientLockingUnlocking);
		// this.remoteClientLockedUnlocked$ = this.store.select(selectRemoteClientLockedUnlocked);
		// this.device$ = this.store.select(selectCurrentDevice);
		this.currentUser$ = this.store.select(selectUser);
		this.isImpersMode$ = this.store.select(selectIsImpersMode);

		this.thGroupShareInvitationRevoking$ = this.store.select(selectThGroupShareInvitationRevoking);
		this.thGroupShareInvitationRevoked$ = this.store.select(selectThGroupShareInvitationRevoked);
		this.thGroupSharingRemoving$ = this.store.select(selectThGroupRemovingSharing);
		this.thGroupRemovedShared$ = this.store.select(selectThGroupRemovedSharing);
	}

	ngOnInit(): void {
		this.filterForm = new FormGroup({
			'searchFilter': new FormControl(''),
			'statusAccepted': new FormControl(true),
			'statusPending': new FormControl(true),
		});
		this.statusType = [
			{ value: '0', label: 'SHARE_ALL' },
			{ value: '1', label: 'SHARE_ACCEPT' },
			{ value: '2', label: 'SHARE_PENDING' },
		];
		this.subscribeAll();
		this.onResize();
	}

	subscribeAll() {
		// this.deviceFinalUserRemoteClientsSub = this.deviceFinalUserRemoteClients$.subscribe(finalUserRemotes => {
		// 	this.finalUserRemotes = finalUserRemotes;
		// });
		this.currentThGroupFinalUsersSub = this.currentThGroupFinalUsers$.subscribe(finalUsers => {
			this.finalUsers = finalUsers;
			this.totalRecords = finalUsers.length;
			this.filterList();
		});
		// this.sharedSub = this.shared$.pipe(filter(sh => !!sh)).subscribe(() => {
		// 	this.store.dispatch(DeviceActions.getFinalUsers());
		// });
		// this.remoteClientDeletedSub = this.remoteClientDeleted$.pipe(filter(d => !!d)).subscribe(() => {
		// 	// this.reloadFinalUserRemoteClients(this.finalUsers);
		// });
		// this.currentDeviceSub = this.currentDevice$.subscribe((device) => {
		// 	this.currentDevice = device;
		// });
		// this.exportingSub = this.exporting$.subscribe((exporting) => {
		// 	this.exporting = exporting;
		// });
		// this.deletingSub = this.deleting$?.subscribe((deleting) => {
		// 	this.deleting = deleting;
		// });
		// this.deletedSub = this.deleted$.subscribe((deleted) => {
		// 	if (deleted) {
		// 		this.store.dispatch(DeviceActions.getFinalUsers());
		// 		this.store.dispatch(UserFileActions.resetFinalUsersList());
		// 	}
		// });
		// this.importingSub = this.importing$?.subscribe(
		// 	(importing) => {
		// 		this.importing = importing;
		// 	}
		// );
		// this.importedSub = this.imported$?.subscribe(
		// 	(imported) => {
		// 		if (imported) {
		// 			this.store.dispatch(DeviceActions.getFinalUsers());
		// 			this.store.dispatch(UserFileActions.resetFinalUsersList());
		// 		}
		// 	}
		// );
		// this.remoteClientDeletingSub = this.remoteClientDeleting$.subscribe(
		// 	(remoteClientDeleting) => {
		// 		this.remoteClientDeleting = remoteClientDeleting;
		// 	}
		// );
		// this.remoteClientLockingUnlockingSub = this.remoteClientLockingUnlocking$?.subscribe(
		// 	(remoteClientLockingUnlocking) => {
		// 		this.remoteClientLockingUnlocking = remoteClientLockingUnlocking;
		// 	}
		// );
		// this.remoteClientLockedUnlockedSub = this.remoteClientLockedUnlocked$?.subscribe(
		// 	(remoteClientLockedUnlocked) => {
		// 		if (remoteClientLockedUnlocked) {
		// 			this.store.dispatch(DeviceActions.resetFinalUserRemoteClients());
		// 		}
		// 	}
		// );
		// this.deviceSub = this.device$.subscribe((device) => {
		// 	this.device = device;
		// });
		this.currentUserSub = this.currentUser$?.subscribe(currentUser => {
			this.currentUser = currentUser;
		});
		this.isImpersModeSub = this.isImpersMode$?.subscribe(
			(isImpersMode) => {
				this.isImpersMode = isImpersMode;
				this.getFinalUsersThGroup();
			}
		);
		this.thGroupShareInvitationRevokingSub = this.thGroupShareInvitationRevoking$?.subscribe(
			(thGroupShareInvitationRevoking) => {
				this.thGroupShareInvitationRevoking = thGroupShareInvitationRevoking;
			}
		);
		this.thGroupShareInvitationRevokedSub = this.thGroupShareInvitationRevoked$?.subscribe(
			(thGroupShareInvitationRevoked) => {
				this.thGroupShareInvitationRevoked = thGroupShareInvitationRevoked;
				this.getFinalUsersThGroup();
			}
		);
		this.thGroupSharingRemovingSub = this.thGroupSharingRemoving$?.subscribe(
			(thGroupRemovingSharing) => {
				this.thGroupSharingRemoving = thGroupRemovingSharing;
			}
		);
		this.thGroupRemovedSharedSub = this.thGroupRemovedShared$?.subscribe(
			(thGroupRemovedShared) => {
				this.thGroupRemovedShared = thGroupRemovedShared;
				this.getFinalUsersThGroup();
			}
		);
		this.filterSub = this.filterForm.valueChanges.pipe(
			debounceTime(500),
		).subscribe(() => {
			this.filterList();
		});
	}

	getFinalUsersThGroup(): void {
		if (this.isImpersMode) {
			this.store.dispatch(DeviceThActions.getFinalUsersThGroup({thGroupId: this.thGroup._id, userId: this.currentUser.Id}));
		} else {
			this.store.dispatch(DeviceThActions.getFinalUsersThGroup({thGroupId: this.thGroup._id}));
		}
	}

	ngOnDestroy(): void {
		this.currentThGroupFinalUsersSub?.unsubscribe();
		// this.deviceFinalUserRemoteClientsSub?.unsubscribe();
		// this.sharedSub?.unsubscribe();
		// this.remoteClientDeletedSub?.unsubscribe();
		// this.currentDeviceSub?.unsubscribe();
		// this.exportingSub?.unsubscribe();
		// this.deletingSub?.unsubscribe();
		// this.deletedSub?.unsubscribe();
		// this.importingSub?.unsubscribe();
		// this.importedSub?.unsubscribe();
		// this.remoteClientDeletingSub?.unsubscribe();
		// this.remoteClientLockingUnlockingSub?.unsubscribe();
		// this.remoteClientLockedUnlockedSub?.unsubscribe();
		// this.deviceSub?.unsubscribe();
		this.currentUserSub?.unsubscribe();
		this.isImpersModeSub?.unsubscribe();

		this.thGroupShareInvitationRevokingSub?.unsubscribe();
		this.thGroupShareInvitationRevokedSub?.unsubscribe();
		this.thGroupSharingRemovingSub?.unsubscribe();
		this.thGroupRemovedSharedSub?.unsubscribe();
	}

	// reloadFinalUserRemoteClients(finalUsers) {
	// 	for (const finalUser of finalUsers) {
	// 		if (finalUser.Id) {
	// 			this.store.dispatch(DeviceActions.getFinalUserRemoteClients({ userId: finalUser.Id }));
	// 		}
	// 	}
	// }

	filterList(): void {
		this.finalUsersFilter = [];
		console.log(this.finalUsers);
		if (this.finalUsers !== undefined && this.finalUsers.length > 0) {
			for (const user of this.finalUsers) {
				if (this.filterStatus(user) && this.filterSearch(user)) {
					this.finalUsersFilter.push(user);
					console.log(this.finalUsersFilter);
				}
			}
		}
		this.totalRecordsFilter = this.finalUsersFilter.length;
	}

	filterStatus(user: User): boolean {
		if (this.f.statusAccepted.value && this.f.statusPending.value) {
			return true;
		}
		if (this.f.statusAccepted.value && user.Id !== null && user.Id !== undefined) {
			return true;
		}
		if (this.f.statusPending.value && (user.Id === null || user.Id === undefined)) {
			return true;
		}
		return false;
	}


	filterSearch(user: User): boolean {
		console.log(this.f.searchFilter.value);
		if (this.f.searchFilter.value === undefined || this.f.searchFilter.value === '') {
			return true;
		}
		if (user.Email.includes(this.f.searchFilter.value) ||
			user.FirstName.includes(this.f.searchFilter.value) ||
			user.LastName.includes(this.f.searchFilter.value)) {
			return true;
		}
		return false;
	}

	isEmptyFinalUsers(): boolean {
		if (this.finalUsers === undefined || this.finalUsers === null || this.finalUsers.length <= 0) {
			return true;
		}
		return false;
	}

	deleteUser(userDelete: User): void {
		this.acceptButtonStyle = "p-button-danger";
		this.rejectButtonStyle = "p-button-secondary";
		this.confirmationService.confirm({
			header: this.translate.instant('DELETE_SHARING'),
			message: this.translate.instant('NEW_UNSHARE_DEVICE_WARNING_1')  + ' <b>' + userDelete.FirstName + ' ' + userDelete.LastName + '</b> ' + 
				this.translate.instant("NEW_UNSHARE_DEVICE_WARNING_2") + ' <b>' + this.thGroup.name + '</b>',
			acceptLabel: this.translate.instant('CONFIRM'),
			rejectLabel: this.translate.instant('CANCEL'),
			icon: 'pi cm-alert',
			accept: () => {
				// delete accepted invitation
				if (this.isImpersMode) {
					return this.store.dispatch(DeviceThActions.removeShareThGroup({ groupId: this.thGroup._id, userDeleteId: userDelete.Id, userId: this.currentUser.Id }));
				} else {
					return this.store.dispatch(DeviceThActions.removeShareThGroup({ groupId: this.thGroup._id, userDeleteId: userDelete.Id }));
				}
			},
			reject: () => {
			}
		});
	}

	revokeUser(user: User): void {
		this.acceptButtonStyle = "p-button-danger";
		this.rejectButtonStyle = "p-button-secondary";
		this.confirmationService.confirm({
			header: this.translate.instant('REVOKE_INVITATION'),
			message: this.translate.instant('NEW_REVOKE_INVITATION_WARNING'),
			acceptLabel: this.translate.instant('CONFIRM'),
			rejectLabel: this.translate.instant('CANCEL'),
			icon: 'pi cm-alert',
			accept: () => {
				// revoke invitation
				if (this.isImpersMode) {
					return this.store.dispatch(DeviceThActions.revokeShareInvitationThGroup({ token: user.InvitationToken, userId: this.currentUser.Id }));
				} else {
					return this.store.dispatch(DeviceThActions.revokeShareInvitationThGroup({ token: user.InvitationToken }));
				}
			},
			reject: () => {
			}
		});
	}

	confirmedUser(user): boolean {
		return !!user.Id;
	}

	// deleteClient(client: RemoteClient): void {
	// 	this.acceptButtonStyle = "p-button-danger";
	// 	this.rejectButtonStyle = "p-button-secondary";
	// 	this.confirmationService.confirm({
	// 		header: this.translate.instant('DELETE_REMOTE_CLIENT_AUTOMATION_HEADER'),
	// 		message: this.translate.instant('DELETE_REMOTE_CLIENT_AUTOMATION_WARNING'),
	// 		acceptLabel: this.translate.instant('CONFIRM'),
	// 		rejectLabel: this.translate.instant('CANCEL'),
	// 		icon: 'pi cm-alert',
	// 		accept: () => {
	// 			this.store.dispatch(DeviceActions.deleteRemoteClient({ slotId: client.Id }));
	// 		},
	// 		reject: () => {
	// 		}
	// 	});
	// }

	// toggleClientLock(client: RemoteClient): void {
	// 	this.store.dispatch(DeviceActions.toggleRemoteClientLock({ slotId: client.Id, locked: !client.Locked }));
	// }

	// changeMaxSlots($event, userId: number): void { // change max slots per final user
	// 	if (userId !== undefined && userId !== null) {
	// 		const slots = this.finalUserRemotes.get(userId);
	// 		slots.MaxSlots = $event.value;
	// 		this.finalUserRemotes.set(userId, slots);
	// 		this.store.dispatch(DeviceActions.changeMaxSlots({ userId, maxRemotes: $event.value }));
	// 	}
	// }

	// claimedSlots(userId: number): RemoteClients {
	// 	return this.finalUserRemotes.get(userId);
	// }

	// claimedSlotsStr(userId: number): string {
	// 	if (this.claimedSlots(userId) !== undefined && this.claimedSlots(userId) !== null) {
	// 		return this.claimedSlots(userId).MaxSlots.toString();
	// 	}
	// 	return "-";
	// }

	// claimedSlotLockedUser(userId: number): string {
	// 	if (this.claimedSlots(userId) !== undefined && this.claimedSlots(userId) !== null &&
	// 		this.claimedSlots(userId).ClaimedSlots !== null && this.claimedSlots(userId).ClaimedSlots.length > 0) {
	// 		let cont = 0;
	// 		for (const user of this.claimedSlots(userId).ClaimedSlots) {
	// 			if (user.Locked) {
	// 				cont++;
	// 			}
	// 		}
	// 		return cont.toString();
	// 	}
	// 	return "0";
	// }

	// includeCategories(categories: number[]): boolean {
	// 	return categories.includes(this.device.CategoryId);
	// }

	// hasImportFinalUsers(): boolean {
	// 	// Categories are included but modelId not supported
	// 	if (this.device.ModelId === EDeviceModel.QBE_MATTER || this.device.ModelId === EDeviceModel.QBE_DONT_AUTOMATION) {
	// 		return false;
	// 	}
	// 	return this.device.CurrentlyOwned && this.includeCategories([EDeviceCategory.Gateway, EDeviceCategory.AlarmSystem, EDeviceCategory.HomeAutomation]);
	// }

	// exportListFinalUser(): void {
	// 	this.store.dispatch(UserFileActions.resetFinalUsersListDialog());
	// 	this.ref = this.dialogService.open(ExportFinalUsersDialogComponent, {
	// 		header: this.translate.instant('EXPORT_LIST_FINAL_USERS'),
	// 		width: '70vw',
	// 		breakpoints: { '1120px': '98vw' },
	// 		contentStyle: { overflow: 'auto' },
	// 	});
	// }

	deleteFinalUsers(): void {
		this.acceptButtonStyle = "p-button-danger";
		this.rejectButtonStyle = "p-button-secondary";
		this.confirmationService.confirm({
			header: this.translate.instant('DELETE_LIST'),
			message: this.translate.instant('DELETE_LIST_WARNING'),
			acceptLabel: this.translate.instant('CONFIRM'),
			rejectLabel: this.translate.instant('CANCEL'),
			icon: 'pi cm-alert',
			accept: () => {
				if (this.isImpersMode) {
					this.store.dispatch(UserFileActions.deleteFinalUsers({ userId: this.currentUser.Id }));
				} else {
					this.store.dispatch(UserFileActions.deleteFinalUsers({}));
				}
			},
			reject: () => { }
		});
	}

	get f(): any {
		return this.filterForm.controls;
	}


	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-23rem');
	}

	simpleInputTextLayout(classType: string): string {
		return StandardPageLayout.simpleInputTextLayout(classType, this.screenWidth);
	}

	col6Resp(): string {
		return StandardPageLayout.col6ResponsiveNoPadding(this.screenWidth);
	}

	col6HeaderPage(position: string) : string {
		return StandardPageLayout.col6HeaderPage(this.screenWidth, position);
	}
}
